import { useContext, useEffect } from 'react';
import FoodSummary from './FoodSummary';
import FoodList from './FoodList';
import CartContext from '../../store/cart-context';

const Home = () => {
  const cartContext = useContext(CartContext);
  
  useEffect(() => {
    cartContext.setShowFooter(true);
  }, []);

  // useEffect(() => {
  //   console.log(cartContext);
  // }, [cartContext]);

  return (
    <>
      {/* <FoodSummary /> */}
      <FoodList />
    </>
  );
};

export default Home;
